
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 500"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M293.6 30.5c40.7-40.7 106.7-40.7 147.3 0 40.7 40.7 40.7 106.7 0 147.3L252.5 366.3c-24.9 24.9-65.3 24.9-90.2 0s-24.9-65.3 0-90.2l154.2-154.2c9.2-9.2 24-9.2 33.1 0 9.1 9.2 9.2 24 0 33.1L195.4 309.2c-6.6 6.6-6.6 17.3 0 24 6.6 6.6 17.3 6.6 24 0l188.4-188.4c22.4-22.4 22.4-58.7 0-81.1s-58.7-22.4-81.1 0L104.1 286.4c-38.2 38.2-38.2 100 0 138.2 38.2 38.1 100 38.1 138.2 0l188.4-188.4c9.2-9.2 24-9.2 33.1 0 9.1 9.2 9.2 24 0 33.1L275.4 457.7c-56.5 56.5-148 56.5-204.4 0-56.5-56.5-56.5-148 0-204.4L293.6 30.5z"}})])
          )
        }
      }
    